import React from 'react';
import { Modal, Text } from '@mantine/core';
import SecondaryButton from './SecondaryButton';
import PrimaryButton from './PrimaryButton';

interface ModalPopupConfirmationComponentProps {
  buttonText: string;
  opened: boolean;
  statusProcess: 'submit' | 'edit' | 'delete';
  open: () => void;
  close: () => void;
  onSubmit: () => void;
  itemLabel?: string;
}

const ModalPopupConfirmationComponent: React.FC<ModalPopupConfirmationComponentProps> = ({
  opened,
  statusProcess,
  close,
  onSubmit,
  itemLabel = 'question'
}) => {
  return (
    <>
      <Modal opened={opened} onClose={close} withCloseButton={false} centered>
        <Text size='xl' fw={700}>
          {statusProcess === 'submit'
            ? 'Submit Confirmation'
            : statusProcess === 'edit'
              ? 'Edit Confirmation'
              : 'Delete Confirmation'}
        </Text>

        <Text c='dimmed' mt={10}>
          You're about to{' '}
          {statusProcess === 'submit' ? 'submit' : statusProcess === 'edit' ? 'edit' : 'delete'}{' '}
          this {itemLabel}. Please ensure all the details you've entered are correct.
        </Text>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '20px'
          }}
        >
          <SecondaryButton text='Cancel' onClick={close} mr={10} />
          <PrimaryButton
            text={
              statusProcess === 'submit' ? 'Submit' : statusProcess === 'edit' ? 'Edit' : 'Delete'
            }
            isDelete={statusProcess === 'delete'}
            onClick={() => {
              onSubmit();
              close();
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default ModalPopupConfirmationComponent;
